import UserService from "rc-app/services/UserService";
import { getAgentById, getAgentProfile } from "./agentActionsApi";
import { getCountryDetails } from "./countryActionsApi";
import { getCustomerProfile } from "./customerActionsApi";

export const getCurrencyList = async () => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_currency?sort_by=created_at&sort_order=-1&page=0&limit=2000`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const getCurrencyListByCode = async (code) => {
  try {
    console.log("code", code);

    // Build the URL with query parameters
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_currency?code=${code}&sort_by=created_at&sort_order=-1&page=0&limit=2000`;

    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching currency list:", error);
    // return [];
    throw error;
  }
};

export const getAgentDefaultCurrency = async (email_id) => {
  try {
    let agentResponse;
    if (UserService.hasRole("agent")) {
      agentResponse = await getAgentProfile(email_id);
    }
    if (UserService.hasRole("customer")) {
      const customerResponse = await getCustomerProfile(email_id);
      agentResponse = await getAgentById(
        customerResponse.customer?.agent_id[0]
      );
    }

    const agentCountry = await agentResponse.agent?.address?.["country"];

    const countryDetails = await getCountryDetails(agentCountry);

    const defaultCurrencyDetails = await getCurrencyListByCode(
      countryDetails?.re_country_details_list[0]?.default_currency_code
    );

    return defaultCurrencyDetails?.re_currency_list[0];
  } catch (error) {
    console.error("Error fetching currency list:", error);
    throw error;
  }
};
